export interface NewsItem {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  category: string;
  imageUrl: string;
  slug: string;
}

export const newsItems: NewsItem[] = [
  {
    id: 1,
    title: "Ouverture des inscriptions pour l'année académique 2026–2027",
    excerpt: 'ESTAD ouvre ses portes aux nouveaux candidats. Découvrez nos programmes en Télécoms, Informatique, Communication et Énergies.',
    content: `L'ESTAD University Institute est heureux d'annoncer l'ouverture des inscriptions pour l'année académique 2026–2027. Cette nouvelle année s'annonce riche en opportunités pour tous les étudiants souhaitant poursuivre une formation d'excellence dans les domaines des technologies de l'information et de la communication.

**Programmes disponibles :**
- Licence et Master en Télécommunications
- Licence et Master en Informatique
- Licence et Master en Communication
- Licence et Master en Énergies Renouvelables

**Dates importantes :**
- Ouverture des inscriptions : 15 Mai 2026
- Clôture des inscriptions : 30 Juin 2026
- Entretiens de sélection : Juillet 2026
- Rentrée académique : Octobre 2026

**Conditions d'admission :**
Pour intégrer l'ESTAD, les candidats doivent posséder le Baccalauréat ou un diplôme équivalent. Une sélection rigoureuse est effectuée sur la base du dossier académique et d'un entretien motivé.

L'institut met à disposition des bourses d'excellence pour les candidats les plus méritants. N'hésitez pas à contacter notre service des admissions pour plus d'informations.

Rejoignez la communauté ESTAD et faites le choix de l'excellence académique au cœur de Yaoundé.`,
    date: '15 Mai 2026',
    category: 'Admissions',
    imageUrl: '/images/campus/doc-ceremony-01.jpg',
    slug: 'ouverture-inscriptions-2026-2027',
  },
  {
    id: 2,
    title: 'Partenariat stratégique avec QH India — Décembre 2024',
    excerpt: 'Signature d\'un accord de coopération académique et scientifique avec QH India, renforçant le rayonnement international d\'ESTAD.',
    content: `L'ESTAD University Institute a le plaisir d'annoncer la signature d'un partenariat stratégique avec QH India, leader international dans le domaine des technologies quantiques et de l'innovation. Cet accord marque une étape importante dans la politique d'internationalisation de notre institution.

**Objectifs du partenariat :**
- Échanges d'étudiants et de chercheurs entre les deux institutions
- Développement de programmes de recherche conjoints
- Organisation de conférences et séminaires internationaux
- Accès aux ressources pédagogiques et laboratoires de QH India

**Bénéfices pour les étudiants :**
Les étudiants de l'ESTAD auront désormais l'opportunité de suivre des modules de formation en Inde, de participer à des projets de recherche internationaux et de bénéficier d'un réseau professionnel mondial.

Ce partenariat s'inscrit dans la vision de l'ESTAD de devenir un acteur majeur de la formation et de la recherche en Afrique, ouvert sur le monde et aux standards internationaux.

La cérémonie de signature s'est déroulée à Yaoundé en présence des représentants des deux institutions et des autorités académiques camerounaises.`,
    date: '20 Décembre 2025',
    category: 'Partenariat',
    imageUrl: '/images/campus/doc-event-03.jpg',
    slug: 'partenariat-qh-india-2024',
  },
  {
    id: 3,
    title: "Journée portes ouvertes — Innovation et Entrepreneuriat",
    excerpt: "Venez découvrir le CATI, nos laboratoires et rencontrer nos enseignants-chercheurs lors de cette journée dédiée à l'innovation.",
    content: `L'ESTAD University Institute vous convie à sa Journée Portes Ouvertes annuelle, placée cette année sous le thème de l'Innovation et de l'Entrepreneuriat. Cet événement est l'occasion idéale de découvrir les installations de notre institution et d'échanger avec notre communauté académique.

**Au programme :**
- Visite guidée du Centre Africain de Technologie et d'Innovation (CATI)
- Démonstrations dans nos laboratoires spécialisés
- Rencontres avec les enseignants-chercheurs et étudiants
- Conférences sur l'entrepreneuriat technologique en Afrique
- Présentation des projets innovants des étudiants
- Sessions d'information sur nos programmes de formation

**Date et horaire :**
Samedi 10 Mars 2026, de 9h00 à 17h00

**Lieu :**
Campus ESTAD, B.P. 14601 Yaoundé

Cette journée est ouverte à tous : futurs étudiants, parents, partenaires, entreprises et tous les curieux souhaitant découvrir l'environnement exceptionnel de l'ESTAD.

Des ateliers pratiques seront organisés tout au long de la journée, permettant aux visiteurs de mieux comprendre les domaines d'excellence de notre institution : Télécommunications, Informatique, Communication et Énergies Renouvelables.

Inscription recommandée via notre site web ou par téléphone au +237 682 29 12 12.`,
    date: '10 Mars 2026',
    category: 'Événement',
    imageUrl: '/images/campus/doc-gathering-02.jpg',
    slug: 'journee-portes-ouvertes-2026',
  },
  {
    id: 4,
    title: "Conférence internationale sur les énergies renouvelables",
    excerpt: "L'ESTAD accueille des experts internationaux pour discuter des défis et opportunités des énergies propres en Afrique.",
    content: `Du 15 au 17 Avril 2026, l'ESTAD University Institute organise la première Conférence Internationale sur les Énergies Renouvelables en Afrique Centrale. Cet événement majeur rassemblera des chercheurs, ingénieurs, décideurs politiques et industriels du monde entier.

**Thématiques abordées :**
- Solaire photovoltaïque et thermique
- Énergie éolienne en contexte africain
- Biomasse et biocarburants
- Réseaux électriques intelligents
- Stockage de l'énergie
- Politiques énergétiques et développement durable

**Intervenants confirmés :**
- Dr. Amadou Diallo, Directeur de l'énergie à la CEDEAO
- Prof. Sarah Johnson, MIT Energy Initiative
- Ing. Jean-Pierre Mbela, Directeur technique de l'ARE (Agence des Énergies Renouvelables)

**Modalités de participation :**
- Inscription en ligne obligatoire
- Frais de participation : 50 000 FCFA (professionnels) / Gratuit (étudiants)
- Attestation de participation délivrée

Les actes de la conférence seront publiés dans une revue scientifique internationale indexée.`,
    date: '15 Avril 2026',
    category: 'Conférence',
    imageUrl: '/images/campus/activity-01.jpg',
    slug: 'conference-energies-renouvelables-2026',
  },
  {
    id: 5,
    title: "Lancement du programme de bourses d'excellence ESTAD 2026",
    excerpt: "L'institut met en place un programme de bourses pour soutenir les étudiants les plus méritants. Dépôt des candidatures jusqu'au 30 juin.",
    content: `Dans le cadre de sa politique d'ouverture sociale et d'excellence académique, l'ESTAD University Institute lance son Programme de Bourses d'Excellence pour l'année académique 2026–2027. Ce programme vise à soutenir financièrement les étudiants les plus méritants.

**Types de bourses disponibles :**
- Bourse d'excellence académique (frais de scolarité intégraux)
- Bourse de mérite (50% des frais de scolarité)
- Bourse d'encadrement recherche (pour les étudiants en Master)
- Bourse mobilité internationale (échanges avec nos partenaires)

**Critères de sélection :**
- Excellent dossier académique (moyenne ≥ 14/20)
- Motivation et projet professionnel clair
- Engagement associatif (un plus)

**Dossier à constituer :**
- Formulaire de candidature en ligne
- Relevés de notes des deux derniers années
- Lettre de motivation détaillée
- Lettres de recommandation (2 minimum)

**Calendrier :**
- Ouverture des candidatures : 1er Mars 2026
- Clôture des dépôts : 30 Juin 2026
- Annonce des lauréats : Août 2026

Pour cette première édition, 20 bourses complètes et 30 bourses partielles seront attribuées.`,
    date: '1 Mars 2026',
    category: 'Bourses',
    imageUrl: '/images/campus/classroom-01.jpg',
    slug: 'bourses-excellence-estad-2026',
  },
  {
    id: 6,
    title: "Visite officielle de la délégation de l'Union Européenne",
    excerpt: "Une délégation de l'UE visite le campus ESTAD pour explorer les opportunités de coopération dans le domaine de la recherche.",
    content: `Le campus de l'ESTAD University Institute a eu l'honneur de recevoir une délégation officielle de l'Union Européenne, conduite par Mme Marie Dupont, responsable du programme de coopération académique UE-Afrique. Cette visite s'inscrit dans le cadre du renforcement des liens entre les institutions d'enseignement supérieur européennes et africaines.

**Programme de la visite :**
- Rencontre avec la direction de l'ESTAD et les corps professoraux
- Visite du Centre Africain de Technologie et d'Innovation (CATI)
- Démonstrations des projets de recherche en cours
- Échanges avec les étudiants bénéficiaires des programmes de mobilité
- Réunion de travail sur les perspectives de partenariat

**Objectifs de la coopération :**
La délégation a exprimé un vif intérêt pour les programmes de recherche de l'ESTAD, notamment dans les domaines des énergies renouvelables et des télécommunications. Des pistes de collaboration ont été identifiées, incluant :
- Programme Erasmus+ pour les échanges étudiants et enseignants
- Financement de projets de recherche conjoints
- Accès aux bases de données scientifiques européennes
- Organisation de conférences internationales

Cette visite marque le début d'une collaboration prometteuse entre l'ESTAD et les institutions européennes, offrant de nouvelles perspectives d'internationalisation pour notre établissement.`,
    date: '5 Février 2026',
    category: 'Visite',
    imageUrl: '/images/campus/entrance.jpg',
    slug: 'visite-delegation-ue-2026',
  },
];

export const getNewsBySlug = (slug: string): NewsItem | undefined => {
  return newsItems.find(item => item.slug === slug);
};

export const getNewsByCategory = (category: string): NewsItem[] => {
  return newsItems.filter(item => item.category === category);
};